module.exports = __webpack_public_path__ + "img/zz8.a8d8992e.png";